function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lager_1",
  "data-name": "Lager 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M121,164.17a39.63,39.63,0,0,0,23.64-3.31c.52-.27,1-.54,1.56-.79A39.63,39.63,0,1,0,116,163c1.89-1.26,10.08-7.25,10.63-17.15a2,2,0,1,1,4,.22C130.11,154.94,124.72,161,121,164.17Zm-14.3-35c-1.33,7.35-8,10-11.32,10.37l-.22,0a2,2,0,0,1-.23-4c.28,0,6.71-.89,7.83-7.1a2,2,0,0,1,3.94.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M93.13,88.53A44.27,44.27,0,1,0,48.86,44.27,44.31,44.31,0,0,0,93.13,88.53ZM106,71.92a18.89,18.89,0,0,0,12.73-3.64,2,2,0,1,1,2.38,3.22A22.92,22.92,0,0,1,107.51,76c-.61,0-1.22,0-1.83-.07a2,2,0,1,1,.32-4ZM64.72,68.7a2,2,0,0,1,2.79-.42,18.93,18.93,0,0,0,12.74,3.64,2,2,0,0,1,.32,4c-.61,0-1.22.07-1.83.07a22.92,22.92,0,0,1-13.6-4.48A2,2,0,0,1,64.72,68.7Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "223.5 219.91 240.47 219.91 231.99 205.78 223.5 219.91"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M148,163.65c-.51.27-1,.54-1.55.79s-.93.49-1.38.76a50.73,50.73,0,0,0-24.38,54.61l-.48.1H178.6s0-.08.05-.11l27.86-46.43A51.32,51.32,0,0,0,148,163.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M134,168.25a43.62,43.62,0,0,1-35-76.1,47.76,47.76,0,0,1-5.89.38A48.34,48.34,0,0,1,44.92,46.76,50,50,0,0,0,0,96.54V219.91H23.25V116a2,2,0,1,1,4,0V219.91h89.4A54.69,54.69,0,0,1,134,168.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M239,170.93l.07-.05L180,72.44c-.61-1.12-1.27-2.21-2-3.27-.43-.72-.67-1.13-.7-1.17l-.06,0a49.92,49.92,0,0,0-35.93-21.26,48.23,48.23,0,0,1-17.74,34.86c1.33-.13,2.67-.2,4-.2a43.62,43.62,0,0,1,31,74.32,55.73,55.73,0,0,1,42.51,8l-25.34-42.23a2,2,0,0,1,3.43-2.06l31.26,52.09c.05.09.09.19.14.29a2,2,0,0,1,.11,2.22l-27.49,45.8h35.2c11.23-18.7,20.34-33.9,20.34-33.9A15,15,0,0,0,239,170.93Z"
})));

function SvgTryggVit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240.92 219.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryggVit);
export default __webpack_public_path__ + "static/media/trygg_vit.843b2c0d.svg";
export { ForwardRef as ReactComponent };